export default function TelegramBanner() {
    return (
      <div className="tg-banner">
        <span className="tg-icon">✈</span>
        <span className="tg-text">
          Get hourly deals on Telegram →{" "}
          <a
            href="https://t.me/aliexpress_best_discount"
            target="_blank"
            rel="noreferrer"
            className="tg-link"
          >
            @aliexpress_best_discount
          </a>
        </span>
      </div>
    );
  }